
export const resolveProfileUIText = ({
  profileCreatedById,
  gender,
  stepKey,
  stepConfig,
}) => {
  if (stepKey === "PROFILE_CREATED_BY") {
    return stepConfig;
  }

 const CREATED_BY = {
  SELF: 1,
  GUARDIAN: 2,   // legacy
  FRIENDS: 3,
  OTHERS: 4,

  FATHER: 5,
  MOTHER: 6,
  BROTHER: 7,
  SISTER: 8, // future safe
};



  const createdBy = profileCreatedById;

  const isGuardianLike =
  createdBy === CREATED_BY.GUARDIAN ||
  createdBy === CREATED_BY.FATHER ||
  createdBy === CREATED_BY.MOTHER ||
  createdBy === CREATED_BY.BROTHER ||
  createdBy === CREATED_BY.SISTER;


  const genderMap = {
    M: { subject: "His", possessive: "his" },
    F: { subject: "Her", possessive: "her" },
  };

// 🔒 Support direct-login resume where gender is stored as "gender"
const resolvedGender =
  gender ||
  localStorage.getItem("selectedGender") ||
  localStorage.getItem("gender");

const hasGender = Boolean(resolvedGender && genderMap[resolvedGender]);

const g = hasGender
  ? genderMap[resolvedGender]
  : { subject: "His/Her", possessive: "his/her" };


//   console.group("[resolveProfileUIText]");
// console.log("stepKey:", stepKey);
// console.log("profileCreatedById:", profileCreatedById);
// console.log("gender param:", gender);
// console.log("localStorage.selectedGender:", localStorage.getItem("selectedGender"));
// console.log("localStorage.gender:", localStorage.getItem("gender"));
// console.log("resolvedGender:", resolvedGender);
// console.log("hasGender:", hasGender);
// console.log("computed g:", hasGender ? genderMap[resolvedGender] : "FALLBACK");
// console.groupEnd();


  /* ---------- TITLE SUBJECT ---------- */

  const subject =
    createdBy === CREATED_BY.SELF
      ? "Your"
      : hasGender
      ? g.subject
      : "His/Her";

  /* ---------- SUBTITLES ---------- */

  const instructionMap = {

    NAME_EMAIL:
  createdBy === CREATED_BY.SELF
    ? "Enter your name. Email and alternate number are optional."
    : createdBy === CREATED_BY.OTHERS
    ? "Enter the person’s name. Optional details can be added later."
     : createdBy === CREATED_BY.FRIENDS
    ? hasGender
      ? `Enter ${g.subject.toLowerCase()} name. Optional details can be added later.`
      : "Enter the name. Optional details can be added later."
    : isGuardianLike
    ? hasGender
      ? `Enter ${g.subject.toLowerCase()} name. Optional details can be added later.`
      : "Enter the name. Optional details can be added later."
    : "Enter the name. Optional details can be added later.",


    GENDER:
      createdBy === CREATED_BY.SELF
        ? "Choose your gender."
        : createdBy === CREATED_BY.OTHERS
        ? "Choose the gender of the person you are registering."
        : "Please choose the gender.",

    DOB_DATE:
      createdBy === CREATED_BY.SELF
        ? "Choose your correct date of birth."
        : "Choose the correct date of birth to continue.",

    DOB_TIME:
      createdBy === CREATED_BY.SELF
        ? "Add your time of birth, if known."
        : "Add the time of birth, if known.",

    MARITAL_STATUS:
      createdBy === CREATED_BY.SELF
        ? "Let us know your current marital status to show suitable matches."
        : hasGender
        ? `Let us know ${g.possessive} current marital status to show suitable matches.`
        : "Let us know the current marital status to show suitable matches.",

    CHILDREN:
      createdBy === CREATED_BY.SELF
        ? "Share details about your children, if any."
        : "Please select the children status.",

    HEIGHT:
      createdBy === CREATED_BY.SELF
        ? "Select your height from the options below to complete your personal details correctly."
        : `Choose the correct height for ${g.possessive} profile from the list below.`,

    EDUCATION:
      "Education details help create a complete and authentic profile and make it easier for families to understand your background.",

    PROFESSION:
      "Adding this information improves profile completeness and increases chances of receiving relevant matches.",

    LIVING_IN:
      "Providing your current living location helps improve profile clarity and match relevance.",

    NATIVE_PLACE:
      "Native place helps families understand your roots and cultural background, which is important for many matchmaking preferences.",

    COMMUNITY:
      createdBy === CREATED_BY.SELF
        ? "Sharing your community information helps us find more suitable matches for you."
        : `Providing ${g.possessive} community information helps ensure better culturally relevant matches.`,

    PHOTO_UPLOAD:
      "Profiles with photos receive more views and better match responses.",

    PRIVACY:
      createdBy === CREATED_BY.SELF
        ? "Control who can view and interact with your profile."
        : "Manage who can view and interact with this profile.",


ABOUT_ME_PARTNER:
  createdBy === CREATED_BY.SELF
    ? "Sharing details about yourself and your preferred partner helps find more compatible and well-aligned matches.your personality."
    : `Sharing details about ${g.possessive} and your preferred partner helps find more compatible and well-aligned matches.your personality.`,

ABOUT_ME:
  createdBy === CREATED_BY.SELF
    ? "Sharing details about yourself helps others understand your personality."
    : "Sharing details about him/her helps others understand personality.",

ABOUT_PARTNER:
  "Describe partner expectations and preferences in detail.",


INFO_FAMILY_OPTIONAL:
  createdBy === CREATED_BY.SELF
    ? "Family details are optional. You may update them anytime from Edit Profile."
    : hasGender
    ? `Family details are optional and can be updated later form ${g.possessive} Edit Profile.`
    : "Family details are optional. You may update the profile anytime from Edit Profile.",

 


  };

  /* ---------- TITLE OVERRIDES ---------- */

  const titleOverrideMap = {
    NATIVE_PLACE:
      createdBy === CREATED_BY.SELF ? "Your Native Place" : "Native Location",

    DOB_DATE:
      createdBy === CREATED_BY.SELF
        ? "When Were You Born?"
        : `${g.subject} Date of Birth`,

        CHILDREN:
  createdBy === CREATED_BY.SELF
    ? "Children Details"
    : "Select Number of Children & Status",

         PROFESSION:
    createdBy === CREATED_BY.SELF
      ? "Your Career Information"
      : `${g.subject} Professional Details`,

      LIVING_IN:
  createdBy === CREATED_BY.SELF
    ? "Your Current Place of Residence"
    : "Current Place of Residence",


      ABOUT_ME_PARTNER:
    createdBy === CREATED_BY.SELF
      ? "About Me & Partner Preferences"
      : `About ${g.subject} & Partner Preferences`,
   
ABOUT_ME: "About Me",

ABOUT_PARTNER: "About Partner",


    
  };

  return {
    title:
      titleOverrideMap[stepKey] ||
      stepConfig.title.replace("{subject}", subject),

    subtitle: stepConfig.subtitle.replace(
      "{instruction}",
      instructionMap[stepKey] || ""
    ),
  };
};
